import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { IntegrationPedidoSharedModule } from './pedido';
import { IntegrationItemSharedModule } from './item';
import { IntegrationClienteSharedModule } from './cliente';
import { IntegrationRepresentanteSharedModule } from './representante';
import { IntegrationTransportadoraSharedModule } from './transportadora';
import { IntegrationNotaFiscalSharedModule } from './nota-fiscal';
import { IntegrationTituloReceberSharedModule } from './titulo-receber';
import { IntegrationComissaoSharedModule } from './comissao';
import { IntegrationCarteiraPedidoSharedModule } from './carteira-pedido';
import { IntegrationClienteGrupoSharedModule } from './cliente-grupo';
import { IntegrationClienteTipoSharedModule } from './cliente-tipo';
import { IntegrationItemTipoSharedModule } from './item-tipo';
import { IntegrationUnidadeNegocioSharedModule } from './unidade-negocio';
import { IntegrationLinhaProducaoSharedModule } from './linha-producao';
import { IntegrationNaturezaVendaSharedModule } from './natureza-venda';

import { IntegrationTipoExecucaoPipe, IntegrationErpSistemaPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule,
        IntegrationPedidoSharedModule,
        IntegrationItemSharedModule,
        IntegrationClienteSharedModule,
        IntegrationRepresentanteSharedModule,
        IntegrationTransportadoraSharedModule,
        IntegrationNotaFiscalSharedModule,
        IntegrationTituloReceberSharedModule,
        IntegrationComissaoSharedModule,
        IntegrationCarteiraPedidoSharedModule,
        IntegrationClienteGrupoSharedModule,
        IntegrationClienteTipoSharedModule,
        IntegrationItemTipoSharedModule,
        IntegrationUnidadeNegocioSharedModule,
        IntegrationLinhaProducaoSharedModule,
        IntegrationNaturezaVendaSharedModule
    ],
    declarations: [
        // Pipes
        IntegrationTipoExecucaoPipe,
        IntegrationErpSistemaPipe
    ],
    exports: [
        IntegrationPedidoSharedModule,
        IntegrationItemSharedModule,
        IntegrationClienteSharedModule,
        IntegrationRepresentanteSharedModule,
        IntegrationTransportadoraSharedModule,
        IntegrationNotaFiscalSharedModule,
        IntegrationTituloReceberSharedModule,
        IntegrationComissaoSharedModule,
        IntegrationCarteiraPedidoSharedModule,
        IntegrationClienteGrupoSharedModule,
        IntegrationClienteTipoSharedModule,
        IntegrationItemTipoSharedModule,
        IntegrationUnidadeNegocioSharedModule,
        IntegrationLinhaProducaoSharedModule,
        IntegrationNaturezaVendaSharedModule,

        // Pipes
        IntegrationTipoExecucaoPipe,
        IntegrationErpSistemaPipe
    ],
    providers: [
        // Pipes
        IntegrationTipoExecucaoPipe
    ]
})
export class IntegrationSharedModule { }
